import React from "react";
import ParentComponent from "../ParentComponent";
import { AuthContext } from "../AuthContext";
import ar from "../../locale";
import { Player } from "video-react";
import "video-react/dist/video-react.css";

export default class VideoUploader extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      video: null,
      videourl: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  cancelFile = () => {
    this.state.video = null;
    this.state.videourl = null;
    this.updateState();
  };

  openPicker = (e) => {
    this.file.click(e);
  };

  onFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.state.video = e.target.files[0];
      this.state.videourl = URL.createObjectURL(e.target.files[0]);
    } else {
      this.state.video = null;
      this.state.videourl = null;
    }
    this.props.onSave(this.state.video, this.state.videourl);
    this.updateState();
  };

  render() {
    let videourl = this.state.videourl || this.props.videourl;
    return (
      <div className="card">
        <div className="card-body">
          <input
            type="file"
            ref={(file) => (this.file = file)}
            className="d-none"
            onChange={this.onFileChange}
            accept="video/*"
          />
          {videourl && (
            <div className="h200 ltr">
              <Player src={videourl}></Player>
            </div>
          )}
          {!videourl && (
            <div className="h200 d-flex flex-column justify-content-center text-center">
              {ar.upload_video_here}
            </div>
          )}
          <div className="mt-2">
            <button
              className="btn btn-info btn-rounded min-w100 ml-1 mr-1"
              onClick={this.openPicker}
            >
              <i className="fa fa-upload" />
            </button>
            {this.state.videourl && (
              <button
                className="btn btn-danger btn-rounded min-w100 ml-1 mr-1"
                onClick={this.cancelFile}
              >
                {ar.cancel}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
